exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field[data-v-0e5a7245] {\n  width: calc(100% - 2px);\n  max-width: calc(100% - 2px);\n  margin-bottom: 0rem !important;\n}\n.bulma .control[data-v-0e5a7245] {\n  max-width: calc(100% - 2px);\n}", ""]);

// exports
